export default "__VITE_ASSET__mzOID0Rp__"